import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { loadingScreenType } from 'src/app/services/util.service';

@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.css'],
    standalone: false
})
export class LoadingScreenComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: loadingScreenType) { }
}
